import type { ChipColor } from '@/types/chip';
import { Box, Typography, Paper, Grid, Chip, IconButton } from '@mui/material';
import { Build, Close, School } from '@mui/icons-material';
import { PageDescription } from '@/components/help';
import { Show } from 'react-admin';
import { useNavigate } from 'react-router-dom';

const STATUS_COLORS: { [key: string]: ChipColor } = {
  Active: 'success',
  Inactive: 'default',
};

export const ServiceDetail = () => {
  const navigate = useNavigate();

  return (
    <Show render={({ record }) => {
      if (!record) return null;

      return (
        <Box sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <IconButton onClick={() => navigate('/services')} size="small" sx={{ color: 'text.secondary' }} aria-label="Close">
              <Close />
            </IconButton>
          </Box>

          <PageDescription
            entity="Service"
            description="A tutoring service offering: subject area, target audience, pricing, and delivery method."
            icon={<School />}
          />

          <Paper elevation={0} sx={{ p: 3, mb: 3, background: 'linear-gradient(135deg, #1565c0, #1976d2)', color: 'primary.contrastText', borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <Build sx={{ fontSize: 48 }} />
              <Box sx={{ flex: 1 }}>
                <Typography variant="h5" fontWeight={700}>{record.name || '—'}</Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>{record.description || '—'}</Typography>
                <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                  <Chip label={record.status} size="small" color={STATUS_COLORS[record.status]} />
                  {record.category && <Chip label={record.category} size="small" variant="outlined" />}
                </Box>
              </Box>
            </Box>
          </Paper>

          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Paper sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <Build color="primary" />
                  <Typography variant="subtitle1" fontWeight={700}>Service Details</Typography>
                </Box>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="caption" color="text.secondary">Name</Typography>
                    <Typography variant="body1" fontWeight={500}>{record.name || '—'}</Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="caption" color="text.secondary">Category</Typography>
                    <Typography variant="body1">{record.category || '—'}</Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="caption" color="text.secondary">Status</Typography>
                    <Typography variant="body1">{record.status || '—'}</Typography>
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="caption" color="text.secondary">Description</Typography>
                    <Typography variant="body1">{record.description || '—'}</Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      );
    }} />
  );
};
